export const productId = {
  china: `?productId=${0}`,
  world: `?productId=${0}`
};